import React, { forwardRef } from "react";
import { Select as ChakraSelect, SelectProps } from "@chakra-ui/react";

type KYDSelectProps = SelectProps & {
  options: { label: string; value: string }[];
};

const KYDSelect = forwardRef<HTMLSelectElement, KYDSelectProps>(
  ({ options, ...props }, ref) => (
    <ChakraSelect
      ref={ref}
      css={{
        paddingInlineStart: "12px",
        "::-ms-value": {
          paddingInlineStart: "12px !important",
        },
        color: "#222",
      }}
      borderRadius="md"
      fontSize="14px"
      boxShadow="0px 0px 10px 0px #0000000D"
      border="1px solid #E6E6E6"
      {...props}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </ChakraSelect>
  )
);

KYDSelect.displayName = "KYDSelect";

export default KYDSelect;
